export default __webpack_public_path__ + "static/media/boxSmokeBg.6a22af06.png";